import { connect } from 'react-redux'
import { getAlbums } from "../../../../selectors/index"
import Albums from './Albums.jsx'

const mapStateToProps = (state) => {
  return {
    albums: getAlbums(state)
  }
}

export default connect(mapStateToProps)(Albums)



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Albums/Albums.js
 **/